import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";

interface TextFieldSuffixProps {
    prefix: string
}

@Dce("TextFieldPrefix")
export default class TextFieldPrefix extends DceComponent<TextFieldSuffixProps> {

    private input: JQuery<HTMLElement>;

    private toggle: JQuery<HTMLElement>;

    constructor(elem: DceHTMLElement, props: TextFieldSuffixProps) {
        super(elem, props);
        this.input = $(elem);
        this.toggle = $('<span class="text-field-suffix">' + props.prefix + '</span>');
        this.addSuffix();
    }

    private addSuffix(){
        let height = parseInt(this.input.css('height'));

        if(height == 0){
            setTimeout(() => {
                this.addSuffix();
            }, 200);
            return;
        }

        var iconHeight = height;
        if(iconHeight > 24){
            iconHeight = 24;
        }

        if(height <= 24){
            iconHeight = 0.8 * height;
        }

        this.toggle.css({
            'font': this.input.css('font'),
            'height': (parseInt(this.input.css('height'))-2) + 'px'
        });

        this.input.before(this.toggle);

        this.toggle.css({
            'margin-right': (-1 * this.toggle.outerWidth()-7) + 'px',
            'padding-left': '5px',
            'padding-right': '2px',
            'left':'1px',
            'position': 'relative',
            'z-index': 2,
            'background-color': '#eee',
            'display': 'inline-block'
        });

        this.input.css({
            'padding-left': (1 * this.toggle.outerWidth() +4) + 'px'
        });

    }

}
